import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  TextField,
  Box,
  Button,
  Typography,
  Divider,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ProfileUpdateInfo from "../../components/ProfileUpdateInfo/ProfileUpdateInfo";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../store/action/profile/profileAction";
import { changePassword, updateProfile } from "../../store/action";
import { useForm } from "react-hook-form";
import Notify from "../../components/Notify/Notify";
import axios from "axios";
import {
  notificationFail,
  notificationSuccess,
} from "../../store/action/notificationMsg";
import ApiConfig from "../../../src/config/ApiConfig";
import PersonIcon from "@material-ui/icons/Person";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import Loading from "../../components/Loading";

const useStyle = makeStyles((theme) => ({
  section: {
    padding: theme.spacing(1, 0),
  },
  card: {
    boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    },
  },
  avatarWrapper: {
    position: "relative",
    width: 140,
    height: 140,
    borderRadius: "50%",
    overflow: "hidden",
    border: `3px solid ${theme.palette.primary.main}`,
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  },
  avatar: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  avatarFallback: {
    width: "100%",
    height: "100%",
    color: theme.palette.text.secondary,
    fontSize: 60,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.palette.grey[100],
  },
  uploadOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "40%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    opacity: 0,
    transition: "opacity 0.3s ease",
    cursor: "pointer",
    "&:hover": {
      opacity: 1,
    },
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
    // color: theme.palette.text.primary,
  },
  formActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
    // marginTop: theme.spacing(3),
  },
}));

const Information = () => {
    const classes = useStyle();
    const dispatch = useDispatch();
    const getToken = localStorage.getItem("token") ? localStorage.getItem("token").replace(/['"]+/g, "") : "";

    const { getProfileList: { data: dataItem }, passChange, passErrors, updateProfileErrors, updateProfileSuccess, loading } = useSelector(state => state.profile)
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const [changePassNotify, setChangePassNotify] = useState(false)
    const [updateProfileNotify, setUpdateProfileNotify] = useState(false)
    // const baseUrl = "http://backendbooking.kanhasoftdev.com/public/uploads/signee_profile_pic/";
    const baseUrl = ApiConfig.API_URL + "uploads/signee_profile_pic/";
    var signeeInfo = JSON.parse(window.localStorage.getItem('signeeInfo'));

    const [data, setData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        contact_number: "",
        address_line_1: "",
        address_line_2: "",
        city: "",
        postcode: "",
        nationality: "",
        date_of_birth: "",
    });

    const [pass, setPass] = useState({
        password: "",
        confirm_password: "",
        old_password: "",
    });

    const handleChange = (e) => {
        e.preventDefault();
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const handlePassChange = (event) => {
        event.preventDefault();
        setPass({ ...pass, [event.target.name]: event.target.value });
    };

    useEffect(() => {
        setData(dataItem);
    }, [dataItem]);

    var StoredData = JSON.parse(window.localStorage.getItem("signeeInfo"));
    const Profile = { id: StoredData?.id };

    useEffect(() => {
        dispatch(getProfile(Profile));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const changePasswordSubmit = () => {
        dispatch(changePassword(pass));
        setChangePassNotify(true);
        reset();
    };

    const updateProfile1 = (e) => {
        e.preventDefault();
        dispatch(updateProfile(data));
        setUpdateProfileNotify(true);
    };

    const setProfilePic1 = (e) => {
        const data11 = e.target.files[0];
        let formData = new FormData();
        formData.append("profile_pic", data11);
        axios.post(ApiConfig.API_URL + "api/signee/upload-profile-picture", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                'Authorization': getToken ? `Bearer ${getToken}` : "",
            },
        }).then((response) => {
            const dataItem = response.data;
            if (dataItem && dataItem.status === true) {
            dispatch(notificationSuccess(dataItem.message));
            signeeInfo.profile_pic = dataItem.data.profile_pic;
            localStorage.setItem("signeeInfo", JSON.stringify(signeeInfo));
            setTimeout(() => {
                window.location.reload();
            }, 2000);
            }
        }).catch((error) => {
            dispatch(notificationFail(error.response.data));
        });
    };

    return (
        <>
        {loading && <Loading open={loading} />}
        {changePassNotify && passErrors?.message && (
            <Notify data={passErrors?.message} status="error" />
        )}
        {changePassNotify && passChange?.message && (
            <Notify data={passChange?.message} status="success" />
        )}
        {updateProfileNotify && updateProfileSuccess?.message && (
            <Notify data={updateProfileSuccess?.message} status="success" />
        )}

        <ProfileUpdateInfo />

        {/* Profile Info */}

        <section className={classes.section}>
            <Typography variant="h5" className={classes.sectionTitle} gutterBottom>My Profile</Typography>

            <form onSubmit={updateProfile1}>
                <Card className={classes.card}>
                    <CardContent style={{padding:0}}>
                        <Grid container spacing={4}>
                            {/* Left: Profile Picture */}
                            <Grid item xs={12} md={3}>
                                <Box display="flex" flexDirection="column" alignItems="center">
                                    <div className={classes.avatarWrapper}>
                                        {data?.profile_pic ? (
                                            <img src={baseUrl + data.profile_pic} alt="Profile" className={classes.avatar}/>
                                        ) : (
                                        <div className={classes.avatarFallback}>
                                            <PersonIcon fontSize="inherit" />
                                        </div>
                                        )}
                                        <label className={classes.uploadOverlay}>
                                            <CameraAltIcon />
                                            <input type="file" hidden onChange={setProfilePic1} />
                                        </label>
                                    </div>
                                    <Typography variant="body2" color="textSecondary" align="center">
                                        Click camera icon to update photo
                                    </Typography>
                                </Box>
                            </Grid>

                            {/* Right: Info */}
                            <Grid item xs={12} md={9}>
                                <Typography variant="h6" className={classes.sectionTitle}>
                                    Basic Information
                                </Typography>
                                <Divider style={{ marginBottom: 24 }} />

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            label="Email"
                                            fullWidth
                                            variant="outlined"
                                            value={data?.email || ""}
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                        label="First Name"
                                        name="first_name"
                                        fullWidth
                                        variant="outlined"
                                        value={data?.first_name || ""}
                                        onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                        label="Last Name"
                                        name="last_name"
                                        fullWidth
                                        variant="outlined"
                                        value={data?.last_name || ""}
                                        onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                        label="Phone Number"
                                        name="contact_number"
                                        fullWidth
                                        variant="outlined"
                                        value={data?.contact_number || ""}
                                        onChange={handleChange}
                                        />
                                    </Grid>

                                    {/* Address Fields */}
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            label="Address Line 1"
                                            name="address_line_1"
                                            fullWidth
                                            variant="outlined"
                                            value={data?.address_line_1 || ""}
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            label="Address Line 2"
                                            name="address_line_2"
                                            fullWidth
                                            variant="outlined"
                                            value={data?.address_line_2 || ""}
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                        label="City"
                                        name="city"
                                        fullWidth
                                        variant="outlined"
                                        value={data?.city || ""}
                                        onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                        label="Postcode"
                                        name="postcode"
                                        fullWidth
                                        variant="outlined"
                                        value={data?.postcode || ""}
                                        onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                        label="Nationality"
                                        name="nationality"
                                        fullWidth
                                        variant="outlined"
                                        value={data?.nationality || ""}
                                        onChange={handleChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* Form Actions */}
                        <Box className={classes.formActions} style={{ marginTop: 24}}>
                            <Button variant="outlined" color="secondary">Cancel</Button>
                            <Button variant="contained" color="primary" type="submit">Save Changes</Button>
                        </Box>
                    </CardContent>
                </Card>
            </form>
        </section>

        {/* Change Password */}
        <section className={classes.section}>
            <Typography variant="h5" className={classes.sectionTitle}>Change Password</Typography>

            <form onSubmit={handleSubmit(changePasswordSubmit)} noValidate autoComplete="off">
                <Card className={classes.card}>
                    <CardContent style={{padding:0}}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    label="Old Password"
                                    name="old_password"
                                    type="password"
                                    fullWidth
                                    variant="outlined"
                                    {...register("old_password", {
                                        required: "Required",
                                        minLength: { value: 5, message: "Min 5 characters" },
                                    })}
                                    onChange={handlePassChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    label="New Password"
                                    name="password"
                                    type="password"
                                    fullWidth
                                    variant="outlined"
                                    {...register("password", {
                                        required: "Required",
                                        minLength: { value: 5, message: "Min 5 characters" },
                                    })}
                                    onChange={handlePassChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    label="Confirm New Password"
                                    name="confirm_password"
                                    type="password"
                                    fullWidth
                                    variant="outlined"
                                    {...register("confirm_password", {
                                        required: "Required",
                                        minLength: { value: 5, message: "Min 5 characters" },
                                    })}
                                    onChange={handlePassChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={3} className={classes.formActions}>
                                <Button type="submit" variant="contained" color="primary">Update Password</Button>
                                <Button variant="outlined" color="secondary" onClick={() => reset()}>Cancel</Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </form>
        </section>
        </>
    );
};

export default Information;
